module.exports = __webpack_public_path__ + "img/qg_thumb_hover.aac3c694.png";